export default __webpack_public_path__ + "static/media/logos.7d0c3c2c.jpg";